

































































































































import branchs from '@/store/types/branchs';
import root from '@/store/types/root';
import { TeipNotifications } from '@/util/teipNotifications';
import copyObj from '@/util/copyObj';
import { mapActions, mapGetters } from 'vuex';
import Vue from 'vue';

export default Vue.extend({
  name: 'BranchProfile',
  data: () => ({
    edit: false,
    active: false,
    branch: {
      name: '',
      address: {
        description: '',
        phone: '',
      },
    },
  }),
  computed: {
    ...mapGetters({
      getSingleBranch: `commerceModule/branches/${branchs.getters.GET_SINGLE_BRANCH}`,
      getProcess: `${root.getters.GET_START_PROCESS}`,
    }),
  },
  created(): void {
    this.defaultValues();
  },
  methods: {
    ...mapActions({
      updateBranch: `commerceModule/branches/${branchs.actions.UPDATE_BRANCH}`,
    }),
    defaultValues(): void {
      this.$data.branch = copyObj(this.getSingleBranch);
      delete this.$data.branch.contacts;
      delete this.$data.branch.id;
      delete this.$data.branch.address.coordinate;
      delete this.$data.branch.address.phone_alternative;
      delete this.$data.branch.users_count;

      if (this.getSingleBranch.status === 'active') {
        this.$data.active = true;
      }
    },
    cancelUpdate(): void {
      this.defaultValues();
      this.$data.edit = false;
    },
    updateProfile(): void {
      const notificacion = new TeipNotifications();
      const data = {
        branch_id: this.$route.params.sucursal_id,
        data: this.$data.branch,
      };
      this.updateBranch(data)
        .then(() => {
          notificacion.success('Sucursal actualizada');
          this.$data.edit = false;
        })
        .catch(() => {
          notificacion.warning(
            '¡Error!',
            'Ha ocurrido un error al actualizar :('
          );
        });
    },
  },
  watch: {
    active(val: boolean): void {
      if (val) {
        this.$data.branch.status = 'active';
      } else {
        this.$data.branch.status = 'inactive';
      }
    },
  },
});
